
import PlanesSalut from "../components/PlanesSalut";
import Bloque02 from "../components/Bloque02";
import styles from "../styles/salut.module.css";
import { Link } from "react-router-dom";


function Salut() {
    return (
        <main>
            <section className={styles.salutSection}>

                <Bloque02
                    imagen=""
                    titulo1="GLOBAL"
                    titulo2="SALUD"
                    tipo="salut"
                    descripcion={
                        <>
                            En <strong> Global Salut</strong> cuidamos de ti como lo harías tú: con respeto, dedicación y humanidad. Nuestro propósito es aliviar, acompañar y mejorar tu salud desde una mirada integradora, respetando tu ritmo y entendiendo tus necesidades. Porque cada cuerpo guarda una historia, y en cada tratamiento buscamos devolverte bienestar, equilibrio y calidad de vida.
                        </>
                    }
                />

                <PlanesSalut ></PlanesSalut>

                <Bloque02
                    imagen="assets/imagen2_bloque03.jpg"
                    titulo1="GLOBAL"
                    titulo2="SALUD"
                    tipo="salut"
                    descripcion={
                        <>
                            En el lado de la Salud de Global nos enfocamos en áreas fundamentales como la postura y el movimiento, con programas de <strong>reeducación postural</strong>, estiramientos terapéuticos, pilates clínico y fortalecimiento del core, orientados a prevenir lesiones y mejorar la movilidad. <br /><br />A través de nuestro servicio de <strong> nutrición funcional</strong>, ofrecemos asesoramiento personalizado para potenciar la recuperación, reducir la inflamación y optimizar el rendimiento físico, especialmente en personas activas o deportistas.<br /><br /> Además, promovemos un enfoque integral del bienestar, combinando cuerpo y mente, con el objetivo de mejorar la calidad de vida de nuestros pacientes a largo plazo, ayudándolos a mantener hábitos sostenibles y un equilibrio saludable en su día a día. <br />
                        </>
                    }
                />

              
                


                
             

                <div className={styles.grid}>

                    <div className={styles.card}>
                        <h3>Postura y Movimiento</h3>
                        <ul>
                            <li>Reeducación postural</li>
                            <li>Estiramientos terapéuticos</li>
                            <li>Pilates clínico</li>
                            <li>Trabajo de core</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3>Nutrición Funcional</h3>
                        <ul>
                            <li>Planes  personalizados</li>
                            <li>Nutrición antiinflamatoria</li>
                            <li>Alimentación para recuperación</li>
                            <li>Apoyo a deportistas</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3>Terapia Osteopática</h3>
                        <ul>
                            <li>Osteopatía estructural</li>
                            <li>Visceral y craneal</li>
                            <li>Liberación miofascial</li>
                            <li>Terapia craneosacral</li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3>Bienestar General</h3>
                        <ul>
                            <li>Masaje terapéutico</li>
                            <li>Mindfulness y respiración</li>
                            <li>Relajación guiada</li>
                            <li>Gestión emocional corporal</li>
                        </ul>
                    </div>
                </div>







      

               


                
            </section>
        
          
        </main>
    );
}

export default Salut;